/**
 * mwApp models
 *
 * @namespace mwApp.models
 */

import AccessoryNoteFactory from './accessoryNote.model'
import AccessoryNoteUpdatesFactory from './accessoryNoteUpdates.model'
import AmountFactory from './amount.model'
import AnnouncementFactory from './announcement.model'
import BannerFactory from './banner.model'
import BannerBundleFactory from './bannerBundle.model'
import CatchupFactory from './catchup.model'
import CatchupChannelFactory from './catchupChannel.model'
import CategoryFactory from './category.model'
import CategorySetFactory from './categorySet.model'
import ChannelCustomDTOFactory from './channelCustomDTO.model'
import ChannelCustomFactory from './channelCustom.model'
import ChannelDTOFactory from './channelDTO.model'
import ChannelFactory from './channel.model'
import CreditCardFactory from './creditCard.model'
import CurrencyFactory from './currency.model'
import CurrencyConverterFactory from './currencyConverter.model'
import DashboardFactory from './dashboard.model'
import DashboardPaymentsFactory from './dashboardPayments.model'
import DashboardSetupFactory from './dashboardSetup.model'
import DeviceFactory from './device.model'
import DeviceSlotFactory from './deviceSlot.model'
import DistributorFactory from './distributor.model'
import EntityCacheFactory from './entityCache.class'
import EntityFactory from './entity.model'
import ExtensionFactory from './extension.model'
import ExternalPaymentSystemFactory from './externalPaymentSystem.model'
import ExternalUserExtraNetworkFactory from './externalUserExtraNetwork.model'
import ExternalUserFactory from './externalUser.model'
import FileUploadMixinFactory from './fileupload.mixin'
import FilterFactory from './filter.model'
import InappSettingsFactory from './inappSettings.model'
import LayoutFactory from './layout.model'
import LiveRewindFactory from './liveRewind.model'
import LiveRewindChannelFactory from './liveRewindChannel.model'
import LocationFactory from './location.model'
import LocalizationFactory from './localization.model'
import MediaUrlFactory from './mediaUrl.model'
import MediaUrlDTOFactory from './mediaUrlDTO.model'
import NetworkCatchupLinkFactory from './networkCatchupLink.model'
import NetworkChannelLinkFactory from './networkChannelLink.model'
import NetworkCurrencyFactory from './networkCurrency.model'
import NetworkCurrencyConverterFactory from './networkCurrencyConverter.model'
import NetworkFactory from './network.model'
import NetworkPaymentSystemFactory from './networkPaymentSystem.model'
import NetworkSettingFactory from './networkSetting.model'
import NetworkThemeLinkFactory from './networkThemeLink.model'
import NoteFactory from './note.model'
import PaymentRequestFactory from './paymentRequest.model'
import PaymentStatementFactory from './paymentStatement.model'
import PaymentSystemFactory from './paymentSystem.model'
import PlaybackTokenGeneratorFactory from './playbackTokenGenerator.model'
import ReportFactory from './report.model'
import ReportSeedFactory from './reportSeed.model'
import ReportStreamFactory from './reportStream.model'
import ReportStreamTemplateFactory from './reportStreamTemplate.model'
import ReportSubscribersFactory from './reportSubscribers.model'
import ReportTemplateFactory from './reportTemplate.model'
import RuleFactory from './rule.model'
import SeasonFactory from './season.model'
import SettingFactory from './setting.model'
import ShelfFactory from './shelf.model'
import ShowFactory from './show.model'
import SubCategoryFactory from './subCategory.model'
import SubThemeFactory from './subTheme.model'
import SubscriberFactory from './subscriber.model'
import SubscriberDTOFactory from './subscriberDTO.model'
import SubscriptionFactory from './subscription.model'
import ThemeFactory from './theme.model'
import TypeFactory from './type.class'
import UserFactory from './user.model'
import VODCustomFactory from './vodCustom.model'
import VODFactory from './vod.model'
import VoucherBatchFactory from './voucherBatch.model'
import VoucherBatchSubscriberLinkFactory from './voucherBatchSubscriberLink.model'
import m2mMixinFactory from './m2m.mixin'
import onOffMixinFactory from './onoff.mixin'
import upDownMixinFactory from './updown.mixin'
import StreamsReportSeedFactory from './streamsReportSeed'
import DashboardDevicesFactory from './dashboardDevices.model'
import DashboardSubscribersFactory from './dashboardSubscribers.model'
import DeviceRedirectsFactory from './deviceRedirects.model'
import ReportSubscribersSeedFactory from './reportSubscribersSeed.model'
import ReportSubscribersTemplateFactory from './reportSubscribersTemplate.model'
import EpisodeFactory from './episode.model'
import SeasonEpisodeFactory from './seasonEpisode.model'
import ReportUsersFactory from './reportUsers.model'
import ReportUsersSeedFactory from './reportUsersSeed.model'
import DRMAccountFactory from './drmAccount.model'
import DRMProfileFactory from './drmProfile.model'
import ReportUsersTemplateFactory from './reportUsersTemplate.model'
import CouponFactory from './coupon.model'
import VODSetFactory from './vodSet.model'
import DiscountFactory from './discount.model'
import ShowSetFactory from './showSet.model'
import AclFactory from './acl.model'
import ReportSubscribersActivityFactory from './reportSubscribersActivity.model'
import ReportSubscribersActivitySeedFactory from './reportSubscribersActivitySeed.model'
import FeaturedCarouselFactory from './featuredCarousel.model'
import PushNotificationFactory from './pushNotification.model'
import EpgFactory from './epg.model'
import StreamFactory from './stream.model'
import StreamCommentDTOFactory from './streamCommentDTO.model'
import StreamInputDTOFactory from './streamInputDTO.model'
import StreamNodeDTOFactory from './streamNodeDTO.model'
import StreamOutputDTOFactory from './streamOutputDTO.model'
import StreamOutputUriDTOFactory from './streamOutputUriDTO.model'
import StreamStatusDTOFactory from './streamStatusDTO.model'
import StreamStatusInputDTOFactory from './streamStatusInputDTO.model'
import StreamStatusOutputDTOFactory from './streamStatusOutputDTO.model'
import StreamStatusOutputProfileDTOFactory from './streamStatusOutputProfileDTO.model'
import StreamBindingFactory from './streamBinding.model'
import DRMDTOFactory from './drmDTO.model'
import ChannelSetFactory from './channelSet.model'
import CustomPriceFactory from './customPrice.model'
import SubscriptionChannelListingFactory from './subscriptionChannelListing.model'
import ChannelGroupFactory from './channelGroup.model'
import FeaturedFactory from './featurd.model'
import LiveEventFactory from './liveEvents.model'
import LiveEventSetFactory from './liveEventSet.model'
import InappSubscriptionFactory from './inappSubscription.model'
import EcwidFactory from './ecwid.model'
import ShoppingCartFactory from './shoppingCart.model'
import openPopupCtrlMixinFactory from '../../common/mixins/openPopupCtrl.mixin'
import PurchaseFactory from './purchase.model'
import UrlPolicyFactory from './urlPolicy.model'
import DefaultStreamFactory from './defaultStream.model'
import PolicedStreamsFactory from './policedStreams.model'
import NoteUpdatesFactory from './noteUpdates.model'
import ProductTourFactory from './productTour.model'
import ContentSetFactory from './contentSet.model'
import SubscriptionAccessoryFactory from './subscriptionAccessory.model'
import SubscriptionPlanFactory from './subscriptionPlan.model'
import PartnerProgramFactory from './partnerProgram.model'
import PartnerProductFactory from './partnerProduct.model'
import NetworkRowFactory from './networkRow.model'
import NetworkColorSchemeFactory from './networkColorScheme.model'
import ReportFinancialFactory from './reportFinancial.model'
import ReportFinancialSeedFactory from './reportFinancialSeed.model'
import ReportFinancialTemplateFactory from './reportFinancialTemplate.model'
import ReportTransactionFactory from './reportTransaction.model'
import ReportTransactionSeedFactory from './reportTransactionSeed.model'
import ReportTransactionTemplateFactory from './reportTransactionTemplate.model'
import LibraryContentFactory from './libraryContent.model'
import SsaiParameterFactory from './ssaiParameter.model'
import DiscountCampaignFactory from './discountCampaign.model'
import MultiSetFactory from './multiSet.model'
import SlotFactory from './slot.model'
import ModuleSettingsFactory from './moduleSettings.model'
import SetrixServerFactory from './setrixServer.model'
import TermsFactory from './terms.model'
import TemplateVariableFactory from './templateVariable.model'
import MovieOfTheNightFactory from './movieOfTheNight.model'

export default
angular.module('mwApp.models', [])
  .factory('AccessoryNote', AccessoryNoteFactory)
  .factory('AccessoryNoteUpdates', AccessoryNoteUpdatesFactory)
  .factory('Acl', AclFactory)
  .factory('Amount', AmountFactory)
  .factory('Announcement', AnnouncementFactory)
  .factory('Banner', BannerFactory)
  .factory('BannerBundle', BannerBundleFactory)
  .factory('Catchup', CatchupFactory)
  .factory('CatchupChannel', CatchupChannelFactory)
  .factory('Category', CategoryFactory)
  .factory('CategorySet', CategorySetFactory)
  .factory('Channel', ChannelFactory)
  .factory('ChannelCustom', ChannelCustomFactory)
  .factory('ChannelCustomDTO', ChannelCustomDTOFactory)
  .factory('ChannelDTO', ChannelDTOFactory)
  .factory('ChannelGroup', ChannelGroupFactory)
  .factory('ChannelSet', ChannelSetFactory)
  .factory('ContentSet', ContentSetFactory)
  .factory('Coupon', CouponFactory)
  .factory('CreditCard', CreditCardFactory)
  .factory('Currency', CurrencyFactory)
  .factory('CurrencyConverter', CurrencyConverterFactory)
  .factory('CustomPrice', CustomPriceFactory)
  .factory('DRMAccount', DRMAccountFactory)
  .factory('DRMDTO', DRMDTOFactory)
  .factory('DRMProfile', DRMProfileFactory)
  .factory('Dashboard', DashboardFactory)
  .factory('DashboardDevices', DashboardDevicesFactory)
  .factory('DashboardPayments', DashboardPaymentsFactory)
  .factory('DashboardSetup', DashboardSetupFactory)
  .factory('DashboardSubscribers', DashboardSubscribersFactory)
  .factory('DefaultStream', DefaultStreamFactory)
  .factory('Device', DeviceFactory)
  .factory('DeviceRedirects', DeviceRedirectsFactory)
  .factory('DeviceSlot', DeviceSlotFactory)
  .factory('Discount', DiscountFactory)
  .factory('DiscountCampaign', DiscountCampaignFactory)
  .factory('Distributor', DistributorFactory)
  .factory('Ecwid', EcwidFactory)
  .factory('Entity', EntityFactory)
  .factory('EntityCache', EntityCacheFactory)
  .factory('Epg', EpgFactory)
  .factory('Episode', EpisodeFactory)
  .factory('Extension', ExtensionFactory)
  .factory('ExternalPaymentSystem', ExternalPaymentSystemFactory)
  .factory('ExternalUser', ExternalUserFactory)
  .factory('ExternalUserExtraNetwork', ExternalUserExtraNetworkFactory)
  .factory('Featured', FeaturedFactory)
  .factory('FeaturedCarousel', FeaturedCarouselFactory)
  .factory('FileUploadMixin', FileUploadMixinFactory)
  .factory('Filter', FilterFactory)
  .factory('InappSettings', InappSettingsFactory)
  .factory('InappSubscription', InappSubscriptionFactory)
  .factory('LibraryContent', LibraryContentFactory)
  .factory('Layout', LayoutFactory)
  .factory('LiveEvent', LiveEventFactory)
  .factory('LiveEventSet', LiveEventSetFactory)
  .factory('LiveRewind', LiveRewindFactory)
  .factory('LiveRewindChannel', LiveRewindChannelFactory)
  .factory('Localization', LocalizationFactory)
  .factory('Location', LocationFactory)
  .factory('MediaUrl', MediaUrlFactory)
  .factory('MediaUrlDTO', MediaUrlDTOFactory)
  .factory('ModuleSettings', ModuleSettingsFactory)
  .factory('MovieOfTheNight', MovieOfTheNightFactory)
  .factory('MultiSet', MultiSetFactory)
  .factory('Network', NetworkFactory)
  .factory('NetworkCatchupLink', NetworkCatchupLinkFactory)
  .factory('NetworkChannelLink', NetworkChannelLinkFactory)
  .factory('NetworkColorScheme', NetworkColorSchemeFactory)
  .factory('NetworkCurrency', NetworkCurrencyFactory)
  .factory('NetworkCurrencyConverter', NetworkCurrencyConverterFactory)
  .factory('NetworkPaymentSystem', NetworkPaymentSystemFactory)
  .factory('NetworkRow', NetworkRowFactory)
  .factory('NetworkSetting', NetworkSettingFactory)
  .factory('NetworkThemeLink', NetworkThemeLinkFactory)
  .factory('Note', NoteFactory)
  .factory('NoteUpdates', NoteUpdatesFactory)
  .factory('PartnerProduct', PartnerProductFactory)
  .factory('PartnerProgram', PartnerProgramFactory)
  .factory('PaymentRequest', PaymentRequestFactory)
  .factory('PaymentStatement', PaymentStatementFactory)
  .factory('PaymentSystem', PaymentSystemFactory)
  .factory('PlaybackTokenGenerator', PlaybackTokenGeneratorFactory)
  .factory('PolicedStreams', PolicedStreamsFactory)
  .factory('ProductTour', ProductTourFactory)
  .factory('Purchase', PurchaseFactory)
  .factory('PushNotification', PushNotificationFactory)
  .factory('Report', ReportFactory)
  .factory('ReportFinancial', ReportFinancialFactory)
  .factory('ReportFinancialSeed', ReportFinancialSeedFactory)
  .factory('ReportFinancialTemplate', ReportFinancialTemplateFactory)
  .factory('ReportTransaction', ReportTransactionFactory)
  .factory('ReportTransactionSeed', ReportTransactionSeedFactory)
  .factory('ReportTransactionTemplate', ReportTransactionTemplateFactory)
  .factory('ReportSeed', ReportSeedFactory)
  .factory('ReportStream', ReportStreamFactory)
  .factory('ReportStreamTemplate', ReportStreamTemplateFactory)
  .factory('ReportSubscribers', ReportSubscribersFactory)
  .factory('ReportSubscribersActivity', ReportSubscribersActivityFactory)
  .factory('ReportSubscribersActivitySeed', ReportSubscribersActivitySeedFactory)
  .factory('ReportSubscribersSeed', ReportSubscribersSeedFactory)
  .factory('ReportSubscribersTemplate', ReportSubscribersTemplateFactory)
  .factory('ReportTemplate', ReportTemplateFactory)
  .factory('ReportUsers', ReportUsersFactory)
  .factory('ReportUsersSeed', ReportUsersSeedFactory)
  .factory('ReportUsersTemplate', ReportUsersTemplateFactory)
  .factory('Rule', RuleFactory)
  .factory('Season', SeasonFactory)
  .factory('SeasonEpisode', SeasonEpisodeFactory)
  .factory('SetrixServer', SetrixServerFactory)
  .factory('Setting', SettingFactory)
  .factory('Shelf', ShelfFactory)
  .factory('Slot', SlotFactory)
  .factory('ShoppingCart', ShoppingCartFactory)
  .factory('Show', ShowFactory)
  .factory('ShowSet', ShowSetFactory)
  .factory('SsaiParameter', SsaiParameterFactory)
  .factory('Stream', StreamFactory)
  .factory('StreamCommentDTO', StreamCommentDTOFactory)
  .factory('StreamInputDTO', StreamInputDTOFactory)
  .factory('StreamNodeDTO', StreamNodeDTOFactory)
  .factory('StreamOutputDTO', StreamOutputDTOFactory)
  .factory('StreamOutputUriDTO', StreamOutputUriDTOFactory)
  .factory('StreamStatusDTO', StreamStatusDTOFactory)
  .factory('StreamStatusInputDTO', StreamStatusInputDTOFactory)
  .factory('StreamStatusOutputDTO', StreamStatusOutputDTOFactory)
  .factory('StreamStatusOutputProfileDTO', StreamStatusOutputProfileDTOFactory)
  .factory('StreamBinding', StreamBindingFactory)
  .factory('StreamsReportSeed', StreamsReportSeedFactory)
  .factory('SubCategory', SubCategoryFactory)
  .factory('SubTheme', SubThemeFactory)
  .factory('Subscriber', SubscriberFactory)
  .factory('SubscriberDTO', SubscriberDTOFactory)
  .factory('Subscription', SubscriptionFactory)
  .factory('SubscriptionAccessory', SubscriptionAccessoryFactory)
  .factory('SubscriptionChannelListing', SubscriptionChannelListingFactory)
  .factory('SubscriptionPlan', SubscriptionPlanFactory)
  .factory('Terms', TermsFactory)
  .factory('Theme', ThemeFactory)
  .factory('Type', TypeFactory)
  .factory('UrlPolicy', UrlPolicyFactory)
  .factory('User', UserFactory)
  .factory('VOD', VODFactory)
  .factory('VODCustom', VODCustomFactory)
  .factory('VODSet', VODSetFactory)
  .factory('VoucherBatch', VoucherBatchFactory)
  .factory('VoucherBatchSubscriberLink', VoucherBatchSubscriberLinkFactory)
  .factory('m2mMixin', m2mMixinFactory)
  .factory('onOffMixin', onOffMixinFactory)
  .factory('openPopupMixin', openPopupCtrlMixinFactory)
  .factory('upDownMixin', upDownMixinFactory)
  .factory('TemplateVariable', TemplateVariableFactory)
